import React from 'react'
import PayCard from '../../../components/comment/paymentCard/paymentCard'

const addeddetail = () => {
  return (
    <div className="add-card-detail-wrap">

   
    <div className="add-detail-wrap">
   
    <div className="rightbar-title">
        Added Card details
    </div>
    
    <div className='saved-card-wrap'>
        <PayCard />
    </div>

    </div>
    </div>
  )
}

export default addeddetail